<template>
    <div>
        <q-table
            ref="table"
            :pagination.sync="server_pagination"
            :data="evaluations"
            :columns="columns"
            @request="requestEvaluations"
            :loading="loading"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            hide-bottom
            class="shadow-0"
            v-if="$q.platform.is.desktop"
            >

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <template slot="body" slot-scope="props">
                <q-tr :props="props" @click.native="showModal(props.row)" :class="getRowClass(props.row)">
                    <q-td key="title" :props="props">
                        {{ props.row.title }}
                    </q-td>

                    <q-td key="qty_questions" :props="props">
                        {{ props.row.qty_questions }}
                    </q-td>

                    <q-td key="answered" :props="props">
                        {{ props.row.answered ? $t('yes') : $t('no') }}
                    </q-td>
                </q-tr>
            </template>
        </q-table>

        <q-card class="bg-grey-1 q-mt-md cursor-pointer" v-for="(eva, index) in evaluations" :key="index" v-if="$q.platform.is.mobile" @click.native="showModal(eva)" :class="getRowClass(eva)">
            <q-card-main class="relative-position">
                <div class="line-card bg-primary absolute-top"></div>

                <div class="row gutter-sm">
                    <div class="col-12">
                        <p class="q-subheading">{{ eva.title }}</p>
                    </div>
                </div>
            </q-card-main>

            <q-card-separator />

            <q-card-actions class="justify-center">
                <q-btn flat :label="eva.qty_questions" icon="fas fa-pen" />
                <q-btn flat :label="eva.answered ? $t('yes') : $t('no')" icon="far fa-check-circle" />
            </q-card-actions>
        </q-card>

        <q-card class="bg-grey-1 cursor-pointer" v-if="evaluations.length == 0">
            <q-card-main class="relative-position">
                <div class="line-card bg-primary absolute-top"></div>

                <div class="row gutter-sm">
                    <div class="col-12">
                        <p class="q-subheading">{{ $t('no_items_found') }}</p>
                    </div>
                </div>
            </q-card-main>
        </q-card>

        <q-modal v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModal()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ evaluation.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm justify-end question-list">
                        <div class="col-xs-12 col-sm-12" v-for="(question, index) in evaluation.questions" :key="index">
                            <p class="q-subheading text-weight-medium q-mb-xs" :class="question.error ? 'text-negative' : ''">{{ index + 1 }}) {{ question.title }}</p>

                            <p class="text-faded" v-if="question.type == 'grade_scale'">
                                <small>{{ $t('grade_from_0_to_10') }}</small>
                            </p>

                            <q-slider
                                v-model="question.answer"
                                :min="0"
                                :max="10"
                                :step="1"
                                label-always
                                snap
                                markers
                                color="secondary"
                                :error="question.error"
                                :readonly="evaluation.answered ? true : false"
                                v-if="question.type == 'grade_scale'"
                                @input="checkAnswer(question)"
                            />

                            <q-input
                                v-model="question.answer"
                                type="textarea"
                                :disable="evaluation.answered ? true : false"
                                :error="question.error"
                                :float-label="$t('comment')"
                                v-if="question.type == 'dissertative'"
                                @input="checkAnswer(question)"
                            />
                        </div>

                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="secondary" :label="$t('answer')" icon="far fa-save" class="full-width" @click="finishTest()" v-if="!evaluation.answered" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            },
            columns: [
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'qty_questions',
                    required: true,
                    label: 'quantity_questions',
                    align: 'left',
                    field: 'qty_questions',
                    sortable: false,
                },
                {
                    name: 'answered',
                    required: true,
                    label: 'answered',
                    align: 'left',
                    field: 'answered',
                    sortable: false,
                },
            ],
            evaluations: [],
            evaluation: [],
            loading: false,
            show_modal: false,
            id_curse : '',
            id_trail: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '90vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        }
    },

    methods: {
        requestEvaluations({ pagination }) {
            this.loading = true
            let new_evaluations = []
            this.selected_server_pagination = pagination
            if (this.$q.platform.is.mobile) this.$q.loading.show()

            let url = ''
            if (this.id_trail == "") {
                url = `/etraining_courses/group_training/${this.id_curse}/get_group_training_evaluations/`
            }
            else {
                url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_curse}/get_group_training_evaluations/`
            }

            this.$axios.get(url, this.getHeader)
            .then(response => {
                response.data.forEach(group_training_evaluation => {
                    let questions = []

                    group_training_evaluation.evaluation_questions.forEach(evaluation_question => {
                        questions.push({
                            type: evaluation_question.group_training_evaluation_question_type,
                            answer: this.getAnswer(evaluation_question),
                            id: evaluation_question.id,
                            title: evaluation_question.title,
                            error: false
                        })
                    })

                    new_evaluations.push({
                        allowed_to_answer: group_training_evaluation.allowed_to_answer,
                        answered: group_training_evaluation.answered,
                        group_training_id: group_training_evaluation.group_training_id,
                        id: group_training_evaluation.id,
                        qty_questions: group_training_evaluation.qty_questions,
                        title: group_training_evaluation.title,
                        questions: questions,
                    })
                })

                this.evaluations = new_evaluations

                this.loading = false
                if (this.$q.platform.is.mobile) this.$q.loading.hide()
            })
            .catch(e => {
                this.loading = false
                if (this.$q.platform.is.mobile) this.$q.loading.hide()
                console.log(e)
            })
        },

        getRowClass(evaluation) {
            if (!evaluation.answered && !evaluation.allowed_to_answer) return 'blocked-activity text-faded'
            else return 'cursor-pointer'
        },

        showModal(evaluation) {
            if (evaluation.answered || evaluation.allowed_to_answer) {
                this.evaluation = evaluation
                this.show_modal = true
            }
        },

        hideModal() {
            this.evaluation = []
            this.requestEvaluations({ pagination: this.server_pagination })
            this.show_modal = false
        },

        getAnswer(question) {
            if(question.group_training_evaluation_question_type == 'grade_scale') {
                if (!question.group_training_evaluation_user_answer_question) return 0
                else return parseInt(question.group_training_evaluation_user_answer_question)
            }
            else {
                return question.group_training_evaluation_user_answer_question
            }
        },

        finishTest() {
            let has_errors = false

            this.evaluation.questions.forEach(question => {
                if (question.type != 'grade_scale') {
                    if (!question.answer) {
                        question.error = true
                        has_errors = true
                    }
                    else {
                        question.error = false
                    }
                }
                else {
                    question.error = false
                }
            })

            if (has_errors) {
                this.$q.notify({
                        message: this.$t('please_answer_all_questions_first'),
                        type: 'negative',
                        icon: 'fas fa-pencil-alt'
                })
            }

            if (!has_errors) {
                this.$q.loading.show()
                let evaluation_questions = []

                this.evaluation.questions.forEach(question => {
                    evaluation_questions.push({
                        id: question.id,
                        group_training_evaluation_user_answer_question: question.answer
                    })
                })

                let data = {
                    evaluation_questions: evaluation_questions
                }

                this.$axios.post(`/etraining_courses/group_training/${this.$route.params.id}/group_training_evaluation/${this.evaluation.id}/submit/`, data, this.getHeader)
                .then(response => {
                    this.$q.loading.hide()

                    this.$q.notify({
                        message: this.$t('reaction_test_submited_with_success'),
                        type: 'positive',
                        icon: 'far fa-save'
                    })

                    this.hideModal()
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
        },

        checkAnswer(question) {
            if (question.type != 'grade_scale') {
                if (question.answer) question.error = false
                else question.error = true
            }
        }
    },

    created() {
        if(this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
        if(this.$route.params.id) this.id_curse = this.$route.params.id
        this.requestEvaluations({ pagination: this.server_pagination })
    }
}
</script>

<style lang="stylus" scoped>
.blocked-activity
    cursor not-allowed

.line-card
    border-top: 3px solid transparent
    border-top-left-radius inherit
    border-top-right-radius inherit
</style>
